<script>

    import ModalContainer from '../$components/modal.container.svelte'

    import ErrorsComponent from './component.errors.svelte'
    import ErrorComponent from './component.error.svelte'

    import View from '../$layouts/view.layout.svelte'
    import TitleHero from '../$components/title.hero.svelte'

</script>

<View>
    <div>
        <TitleHero title="Errores" subtitle="Consulta y gestión de errores" />
        <ErrorsComponent />
    </div>
</View>

<ModalContainer id="error_modal" title="Error">
    <ErrorComponent />
</ModalContainer>